'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Gif = function Gif(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    d: "M16.324 0a4 4 0 014 4v12a4 4 0 01-4 4h-12a4 4 0 01-4-4V4a4 4 0 014-4h12zm-4.782 7H9.979v6h1.563V7zM7.375 7H4.25c-.625 0-1.042.5-1.042 1v4c0 .5.417 1 1.042 1h3.125c.625 0 1.042-.5 1.042-1v-2H6.854v1.5H4.771v-3h3.646V8c0-.5-.417-1-1.042-1zm10.417 0h-4.688v6h1.563v-2h2.083V9.5h-2.083v-1h3.125V7z"
  }));
};

var Gif$1 = iconStyles()(Gif);

module.exports = Gif$1;
